import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import QuestionItem from "../components/QuestionItem.vue";
import { getAppraiseDetail } from "@/api/exam";
let AppraisePreview = class AppraisePreview extends Vue {
    constructor() {
        super(...arguments);
        this.objectiveLayout = false;
        this.subjectiveLayout = true;
        this.userId = '';
        this.joinId = '';
        this.nickName = '';
        this.subTime = '';
        this.during = '';
        this.userTotalScore = '--';
        this.objectivelyResult = {
            successNum: 0,
            failNum: 0,
            noAnsweredNum: 0,
            score: 0
        };
        this.contentAppId = '';
        this.objectiveQuestionList = [];
        this.essayList = [];
        this.isShowLoading = true;
    }
    created() {
        const query = this.$route.query;
        this.userId = query.user_id;
        this.joinId = query.id;
        this.getUserInfo();
        this.contentAppId = query.content_app_id || '';
    }
    async getUserInfo() {
        this.isShowLoading = true;
        try {
            const res = await getAppraiseDetail({
                userId: this.userId,
                examResultId: this.joinId
            });
            const data = res.data.data;
            this.nickName = data.nickName;
            this.subTime = data.commitTime;
            this.during = this.formatTimeString(data.useDuration);
            this.userTotalScore = data.score;
            this.objectivelyResult = data.objectivelyResult;
            this.objectiveQuestionList = data.objectivelyList || [];
            this.essayList = data.subjectivelyList || [];
            this.objectiveLayout = 0 === this.essayList.length;
        }
        catch (_) { }
        finally {
            this.isShowLoading = false;
        }
    }
    formatTimeString(s) {
        var hour = Math.floor(s / 3600), minute = Math.floor(s % 3600 / 60), second = Math.floor(s % 3600 % 60);
        let time = '';
        if (hour > 0) {
            time += `${hour}小时`;
        }
        if (minute > 0) {
            time += `${minute}分钟`;
        }
        time += `${second}秒`;
        return time;
    }
};
AppraisePreview = tslib_1.__decorate([
    Component({
        name: 'AppraisePreview',
        components: {
            QuestionItem
        }
    })
], AppraisePreview);
export default AppraisePreview;
